import { useMutation } from 'react-query';
import { deletePresentation } from 'src/services/api/presentations';

function useDeletePresentation() {
  return useMutation((presentation) => deletePresentation(presentation));
}

export default useDeletePresentation;
